import React from 'react';
import {ReactButton} from '@gongxigames/framework/core/fragments/react';

type StartButtonProps = {
    onClick: () => void;
};

export function StartButton({onClick}: StartButtonProps): JSX.Element {
    return <ReactButton
        name={'StartButton'}
        round={20}
        textStyleId={'AutoplayPopupStartButtonText'}
        textId={'buttonStart'}
        onClick={onClick}
        backgroundColor={0x06b200}
        horizontalPadding={45}
        verticalPadding={25}
    />;
}
